import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-output',
  templateUrl: './output.component.html',
  styleUrls: ['./output.component.scss']
})
export class OutputComponent implements OnInit {
  @Input() component: any;
  @Input() formDesign: any;
  @Output() onChangeEmitter: any = new EventEmitter();
  @Input() formState: any;

  myState: any = "";

  constructor() { }

  ngOnInit() {
    if (this.formState) {
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  ngOnChanges(c: any) {
    if (this.formState) {
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  onChange(e: any) {
    console.log(this.myState)
    this.onChangeEmitter.emit({
      component: this.component,
      eventType: "valueChange",
      value: e.target.value
    })
  }

  formatOutput(val: string | Number) {
    if (!val) return "0";
    val = val.toString().replace(/,/g, "")
    if(this.component.element.show_decimal != true) {
      val = parseInt(val).toString()
    } else {
      val = parseFloat(val).toString()
    }
    let result: any[] = []
    for (var i = val.length - 1; i >= 0; i--) {
      result.push(val[i])
      if (result.length != 0 && (val.length - i) % 3 == 0) {
        result.push(",")
      }
    }
    if(result[result.length-1] == ',')  {
      result.pop();
    }
    return result.reverse().join("");
  }

  checkNAN(val: any) {
    return isNaN(Number(val));
  }
}
